import { useState, useEffect } from 'react';

const createAuthContext = ({ testLogged, loginUrl, redirectToInsteadOfPopup = null, acceptedAuthSuccessOrigin, }) => {
    const popupSuccessAcceptedOrigin = acceptedAuthSuccessOrigin
        ? typeof acceptedAuthSuccessOrigin === 'string'
            ? [acceptedAuthSuccessOrigin]
            : acceptedAuthSuccessOrigin
        : [];
    let context = {
        authPromise: null,
        testLogged,
        loginUrl,
        startAuth() {
            if (redirectToInsteadOfPopup) {
                window.location.href = `${redirectToInsteadOfPopup}?from=${window.location.href}`;
                return;
            }
            return new Promise((resolve, reject) => {
                let alreadyResolved = false;
                const popup = window.open(`${loginUrl}?from=${window.location.href}`, '_blank', 'width=400,height=400');
                const popupClosedChecker = setInterval(() => {
                    if (popup.closed) {
                        window.removeEventListener('message', listener);
                        context.authPromise = null;
                        clearInterval(popupClosedChecker);
                        if (alreadyResolved) {
                            return;
                        }
                        reject(new Error(`Authentication popup has been closed.`));
                    }
                }, 1000);
                function listener(event) {
                    if ((event.origin === window.location.origin ||
                        popupSuccessAcceptedOrigin.includes(event.origin)) &&
                        event.data === 'login-success') {
                        window.removeEventListener('message', listener);
                        context.authPromise = null;
                        clearInterval(popupClosedChecker);
                        alreadyResolved = true;
                        resolve();
                    }
                }
                window.addEventListener('message', listener);
            });
        },
        async waitAuth() {
            if (!context.authPromise) {
                context.authPromise = auth.startPopupAuth();
            }
            await context.authPromise;
        },
    };
    const auth = {
        context,
        startPopupAuth() {
            return context.startAuth();
        },
        async fetch(req, init = null) {
            const res = await fetch(req, Object.assign({ credentials: 'include' }, init));
            if (res.status === 403) {
                // Retry auth
                await context.waitAuth();
                // Then retry fetch
                return fetch(req, Object.assign({ credentials: 'include' }, init));
            }
            return res;
        },
    };
    return auth;
};
const Authenticated = ({ context, children, renderLoading = () => null, }) => {
    const [logged, setLogged] = useState(false);
    useEffect(() => {
        context.testLogged().then((isLogged) => {
            if (isLogged) {
                if (window.opener) {
                    // is an auth popup
                    window.opener.postMessage('login-success', window.location.origin);
                    window.close();
                }
                else {
                    setLogged(true);
                }
            }
            else {
                if (window.opener) {
                    return context.waitAuth();
                }
                else {
                    // Redirect to login
                    window.location.href = `${context.loginUrl}?from=${window.location.href}`;
                }
            }
        });
    }, []);
    if (!logged) {
        return renderLoading();
    }
    return children;
};

export { Authenticated, createAuthContext };
